export default __webpack_public_path__ + "static/rsz_swietliki2-690f1afbabbe92f86d607e24573630c1.png";